var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A0A0A0;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.2,248.1C496.2,111.1,385.1,0,248.1,0C111.1,0,0,111.1,0,248.1c0,137,111.1,248.1,248.1,248.1 C385.1,496.2,496.2,385.1,496.2,248.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.2,173.6c0-13.9,4.5-28,13.4-42.3c8.9-14.3,22-26.1,39.1-35.5c17.1-9.4,37.1-14.1,60-14.1 c21.2,0,40,3.9,56.3,11.8c16.3,7.8,28.8,18.5,37.7,32c8.9,13.5,13.3,28.1,13.3,43.9c0,12.5-2.5,23.4-7.6,32.7 c-5.1,9.4-11.1,17.5-18,24.3c-7,6.8-19.4,18.3-37.5,34.4c-5,4.5-9,8.5-12,12c-3,3.4-5.2,6.6-6.7,9.4c-1.5,2.9-2.6,5.7-3.4,8.6 c-0.8,2.9-2,7.9-3.6,15.1c-2.8,15.2-11.5,22.9-26.1,22.9c-7.6,0-14-2.5-19.2-7.5c-5.2-5-7.8-12.4-7.8-22.2c0-12.3,1.9-23,5.7-32 c3.8-9,8.9-16.9,15.2-23.7c6.3-6.8,14.8-14.9,25.5-24.3c9.4-8.2,16.1-14.4,20.3-18.6c4.2-4.2,7.7-8.8,10.5-14 c2.9-5.1,4.3-10.7,4.3-16.7c0-11.7-4.4-21.6-13.1-29.7c-8.7-8.1-20-12.1-33.7-12.1c-16.1,0-28,4.1-35.6,12.2 c-7.6,8.1-14.1,20.1-19.3,35.9c-5,16.6-14.4,24.8-28.3,24.8c-8.2,0-15.1-2.9-20.8-8.7C141,186.6,138.2,180.3,138.2,173.6z  M245.4,414.4c-8.9,0-16.7-2.9-23.4-8.7c-6.7-5.8-10-13.9-10-24.3c0-9.2,3.2-17,9.7-23.3c6.4-6.3,14.4-9.4,23.7-9.4 c9.2,0,17,3.2,23.3,9.4c6.3,6.3,9.4,14.1,9.4,23.3c0,10.3-3.3,18.3-9.9,24.2C261.7,411.5,254.1,414.4,245.4,414.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.1cdec4f63202c6b0d7c606549c150120.svg";
export { ForwardRef as ReactComponent };